/** Manual related-article scrolling, including theme-editor reloads. */
export class ArticleFooter extends HTMLElement {
  connectedCallback() {
    this.disconnectedCallback()
    const cards = this.querySelector('[data-article-footer-cards]')
    const controls = this.querySelector('[data-article-footer-controls]')
    const previous = this.querySelector('[data-article-footer-previous]')
    const next = this.querySelector('[data-article-footer-next]')
    const progress = this.querySelector('[data-article-footer-progress]')
    const progressFill = this.querySelector(
      '[data-article-footer-progress-fill]'
    )
    if (!cards || !controls || !previous || !next) return

    this.abort = new AbortController()
    const { signal } = this.abort
    const update = () => {
      const end = Math.max(0, cards.scrollWidth - cards.clientWidth)
      controls.hidden = end <= 1
      if (progress && progressFill) {
        progress.hidden = end <= 1
        const position = Math.max(0, Math.min(end, cards.scrollLeft))
        const fraction =
          cards.scrollWidth > 0
            ? Math.min(1, (position + cards.clientWidth) / cards.scrollWidth)
            : 0
        progressFill.style.transform = `scaleX(${fraction})`
      }
      previous.disabled = cards.scrollLeft <= 1
      next.disabled = cards.scrollLeft >= end - 1
    }
    const scroll = (direction) => {
      const first = cards.children[0]
      if (!first) return
      const gap = Number.parseFloat(getComputedStyle(cards).columnGap) || 0
      const distance = first.getBoundingClientRect().width + gap
      const end = Math.max(0, cards.scrollWidth - cards.clientWidth)
      cards.scrollTo({
        left: Math.max(
          0,
          Math.min(end, cards.scrollLeft + direction * distance)
        ),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
          ? 'instant'
          : 'smooth'
      })
    }
    previous.addEventListener('click', () => scroll(-1), { signal })
    next.addEventListener('click', () => scroll(1), { signal })
    cards.addEventListener('scroll', update, { passive: true, signal })
    window.addEventListener('resize', update, { signal })
    if (typeof ResizeObserver !== 'undefined') {
      this.observer = new ResizeObserver(update)
      this.observer.observe(cards)
    }
    update()
  }

  disconnectedCallback() {
    this.abort?.abort()
    this.observer?.disconnect()
  }
}

if (!customElements.get('aurate-article-footer')) {
  customElements.define('aurate-article-footer', ArticleFooter)
}
